import { request } from '../sharedLegacy/utils'

export const getLiveRealtimeData = (liveId, presenterToken) => {
  const url = '/api/live/realtime'
  const data = {
    live_id: liveId,
  }

  if (presenterToken) {
    data.presenter_token = presenterToken
  }

  return request({
    url,
    method: 'GET',
    data,
  })
}

export const updateLive = (data = {}, liveId = undefined) => {
  return request({
    url: '/api/live/update',
    data: {
      ...data,
      live_format: 'webinar',
      live_id: liveId,
    },
  })
}
